import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class FeriadoValidation extends DefaultValidation {

    constructor(msgs, moment) {
        super(msgs);
        this.moment = moment;
    }

    validate(model, refs) {
        let valid = true;

        if (!model.descricao) {
            refs.descricaoInput.focusedOut = true;
            this.showMessage(new Message('error', 'msg-campos-obrigatorios', true));
            valid = false;
        }

        if (!model.data) {
            refs.dateInput.focusedOut = true;
            this.showMessage(new Message('error', 'msg-data-invalida', true));
            valid = false;
        }

        /* Só validar o ano retroativo para novos feriados */
        if (valid && !model.id) {
            // Data vem em formato YYYY-MM-DD
            let now = this.moment();
            let date = this.moment(model.data, 'YYYY-MM-DD');

            if (date.isBefore(now, 'year')) {
                this.showMessage(new Message('error', 'msg-feriado-ano-nao-retroativo', true));
                valid = false;
            }

        }

        return valid;
    }

}